export const CUSTOM_BUTTON_PROPS = {
	size: "small",
	width: "125px",
};
